import { render } from "./DialogTitleBar.vue?vue&type=template&id=2fd5d9ce&scoped=true"
const script = {}

import "./DialogTitleBar.vue?vue&type=style&index=0&id=2fd5d9ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd5d9ce"]])

export default __exports__